import React, { useState } from 'react';
import {
  Switch,
  Box,
  Text,
  useColorMode,
  useColorModeValue,
} from '@chakra-ui/react';

function SettingsPage() {
  const { toggleColorMode } = useColorMode();
  const handleDarkModeToggle = () => {
    toggleColorMode();
  };

  return (
    <Box position="relative">
      <Text fontSize="large" fontWeight="700" mb="4">
        Settings:
      </Text>
      
     
      
      <Box display="flex" alignItems="center" width="300px">
        <Text fontSize="medium" mr="3">
          Dark Mode:
        </Text>
        <Switch
          isChecked={useColorModeValue(false, true)}
          onChange={handleDarkModeToggle}
          size="md"
          colorScheme="teal"
        />
      </Box>
    </Box>
  );
}

export default SettingsPage;
